import styled from 'styled-components';

const props = props => props;

const TextField = styled.input.attrs({ type: props.type })`
  border: 4px solid #d1d1d1;
  border-radius: 10px;
  height: 40px;
  font-size: 24px;
  padding-left: 10px;
  width: 100%;
  @media(min-width: 1024px) {
    width: ${props => (props.small ? '147px' : '')};
  }
  &:focus {
    border: 4px solid #42e2ee;
  }
`;

export default TextField;



// WEBPACK FOOTER //
// ./src/elements/TextField.js